// pages/AddNew.jsx
import React, { useEffect, useState } from 'react';
import apiClient from '../config/api';
import Navbar from '../components/Navbar';
import UploadForm from '../components/UploadForm';
import { styles } from '../styles/newstyles';

const AddNew = ({ onLogout }) => {
  const [username, setUsername] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);

  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [counties, setCounties] = useState([]);

  const [files, setFiles] = useState([]);
  const [attachmentCategoryID, setAttachmentCategoryID] = useState('');
  const [attachmentTypeID, setAttachmentTypeID] = useState('');
  const [countyId, setCountyId] = useState('');
  const [description, setDescription] = useState('');
  const [appraisalYear, setAppraisalYear] = useState(String(new Date().getFullYear()));
  const [isAdminOnly, setIsAdminOnly] = useState('');

  const [message, setMessage] = useState('');
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});

  // NEW: key used to force-remount UploadForm (fresh internal state) after "upload again"
  const [formKey, setFormKey] = useState(() => Date.now());

  useEffect(() => {
    apiClient.get('/auth/session', { withCredentials: true })
      .then(res => {
        if (res.data?.username) setUsername(res.data.username);
        if (res.data?.isAdmin) {
          setIsAdmin(true);
          apiClient.get('/lookup/counties')
            .then(r => setCounties(r.data))
            .catch(e => console.error('Failed to fetch counties', e));
        }
      })
      .catch(err => console.error('Failed to fetch session:', err));

    apiClient.get('/lookup/categories')
      .then(r => setCategories(r.data))
      .catch(e => console.error('Failed to fetch categories', e));

  }, []);

  const handleCategoryChange = (e) => {
    const selectedCategoryId = e.target.value;
    setAttachmentCategoryID(selectedCategoryId);
    setAttachmentTypeID('');
    if (selectedCategoryId) {
      apiClient.get(`/lookup/types/${selectedCategoryId}`)
        .then(r => setTypes(r.data))
        .catch(e => console.error('Failed to fetch types', e));
    } else {
      setTypes([]);
    }
  };

  const handleRemoveFile = (index) => setFiles(prev => prev.filter((_, i) => i !== index));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (files.length === 0 || !attachmentCategoryID || !attachmentTypeID) {
      setMessage('Please fill all required fields.'); return;
    }
    if (isAdmin && isAdminOnly === '') {
      setMessage('Please select document visibility (Internal or Client).'); return;
    }
    if (description.trim().split(/\s+/).length > 100) {
      setMessage('Description exceeds 100 word limit.'); return;
    }

    setIsLoading(true); setMessage('');
    const progressMap = {};

    try {
      const formData = new FormData();
      files.forEach(file => formData.append('file', file));
      formData.append('attachmentCategoryID', attachmentCategoryID);
      formData.append('attachmentTypeID', attachmentTypeID);
      formData.append('description', description);
      formData.append('appraisalYear', appraisalYear);
      if (isAdmin && countyId) formData.append('countyId', countyId);
      if (isAdmin) {
        formData.append('isAdminOnly', isAdminOnly);
      }

      await apiClient.post('/files/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true,
        onUploadProgress: (evt) => {
          const percent = Math.round((evt.loaded * 100) / evt.total);
          files.forEach(file => {
            progressMap[file.name] = percent;
          });
          setUploadProgress({ ...progressMap });
        }
      });

      setMessage('All files uploaded successfully!');
      setUploadSuccess(true);

      // reset form
      setAttachmentCategoryID('');
      setAttachmentTypeID('');
      setDescription('');
      setCountyId('');
      setFiles([]);
      setUploadProgress({});
    } catch (error) {
      const msg = error.response?.data?.details || 'One or more uploads failed.';
      setMessage(msg);
      setUploadSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setAttachmentCategoryID('');
    setAttachmentTypeID('');
    setDescription('');
    setCountyId('');
    setTypes([]);
    setFiles([]);
    setUploadProgress({});
    setAppraisalYear(String(new Date().getFullYear()));
    setIsAdminOnly('');
  };

  // NEW: called by UploadForm's success screen "upload again" link
  const handleUploadAgain = () => {
    // Clear any success/message state at the parent level
    setUploadSuccess(false);
    setMessage('');
    // Ensure the controlled inputs are clean
    setAttachmentCategoryID('');
    setAttachmentTypeID('');
    setDescription('');
    setCountyId('');
    setTypes([]);
    setFiles([]);
    setUploadProgress({});
    setAppraisalYear(String(new Date().getFullYear()));
    setIsAdminOnly('');
    // Force-remount the UploadForm (clears any of its internal UI flags)
    setFormKey(Date.now());
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (_) {}
  };

  return (
    <div style={styles.mainContainer}>
      <Navbar username={username} onLogout={onLogout} isAdmin={isAdmin} />
      <UploadForm
        key={formKey}                 /* NEW: remount trigger */
        onUploadAgain={handleUploadAgain}  /* NEW: lets success screen reload the form */
        {...{
          categories, types, counties, isAdmin,
          files, attachmentCategoryID, attachmentTypeID, countyId, description,
          appraisalYear, setAppraisalYear, isAdminOnly, setIsAdminOnly,
          isLoading, message, uploadSuccess, styles,
          handleCategoryChange, setAttachmentTypeID, setCountyId, setDescription, setFiles,
          handleSubmit, handleCancel, handleRemoveFile, uploadProgress
        }}
      />
    </div>
  );
};

export default AddNew;



























// // pages/AddNew.jsx
// import React, { useEffect, useState } from 'react';
// import apiClient from '../config/api';
// import Navbar from '../components/Navbar';
// import UploadForm from '../components/UploadForm';
// import { styles } from '../styles/newstyles';

// const AddNew = ({ onLogout }) => {
//   const [username, setUsername] = useState('');
//   const [isAdmin, setIsAdmin] = useState(false);

//   const [categories, setCategories] = useState([]);
//   const [types, setTypes] = useState([]);
//   const [allTypes, setAllTypes] = useState([]);
//   const [counties, setCounties] = useState([]);

//   const [files, setFiles] = useState([]);
//   const [attachmentCategoryID, setAttachmentCategoryID] = useState('');
//   const [attachmentTypeID, setAttachmentTypeID] = useState('');
//   const [countyId, setCountyId] = useState('');
//   const [description, setDescription] = useState('');

//   const [message, setMessage] = useState('');
//   const [uploadSuccess, setUploadSuccess] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState({});

//   useEffect(() => {
//     apiClient.get('http://www.typortal.com/api/auth/session', { withCredentials: true })
//       .then(res => {
//         if (res.data?.username) setUsername(res.data.username);
//         if (res.data?.isAdmin) {
//           setIsAdmin(true);
//           apiClient.get('http://www.typortal.com/api/lookup/counties')
//             .then(r => setCounties(r.data))
//             .catch(e => console.error('Failed to fetch counties', e));
//         }
//       })
//       .catch(err => console.error('Failed to fetch session:', err));

//     apiClient.get('http://www.typortal.com/api/lookup/categories')
//       .then(r => setCategories(r.data))
//       .catch(e => console.error('Failed to fetch categories', e));

//     apiClient.get('http://www.typortal.com/api/lookup/types')
//       .then(r => setAllTypes(r.data))
//       .catch(e => console.error('Failed to fetch all types', e));
//   }, []);

//   const handleCategoryChange = (e) => {
//     const selectedCategoryId = e.target.value;
//     setAttachmentCategoryID(selectedCategoryId);
//     setAttachmentTypeID('');
//     if (selectedCategoryId) {
//       apiClient.get(`http://www.typortal.com/api/lookup/types/${selectedCategoryId}`)
//         .then(r => setTypes(r.data))
//         .catch(e => console.error('Failed to fetch types', e));
//     } else {
//       setTypes([]);
//     }
//   };

//   const handleRemoveFile = (index) => setFiles(prev => prev.filter((_, i) => i !== index));

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (files.length === 0 || !attachmentCategoryID || !attachmentTypeID) {
//       setMessage('Please fill all required fields.'); return;
//     }
//     if (description.trim().split(/\s+/).length > 100) {
//       setMessage('Description exceeds 100 word limit.'); return;
//     }

//     setIsLoading(true); setMessage('');
//     const progressMap = {};

//     try {
//       await Promise.all(files.map(file => {
//         const formData = new FormData();
//         formData.append('file', file);
//         formData.append('attachmentCategoryID', attachmentCategoryID);
//         formData.append('attachmentTypeID', attachmentTypeID);
//         formData.append('description', description);
//         if (isAdmin && countyId) formData.append('countyId', countyId);

//         return apiClient.post('http://www.typortal.com/api/files/upload', formData, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           withCredentials: true,
//           onUploadProgress: (evt) => {
//             progressMap[file.name] = Math.round((evt.loaded * 100) / evt.total);
//             setUploadProgress({ ...progressMap });
//           }
//         });
//       }));

//       setMessage('All files uploaded successfully!');
//       setUploadSuccess(true);

//       // reset form
//       setAttachmentCategoryID('');
//       setAttachmentTypeID('');
//       setDescription('');
//       setCountyId('');
//       setFiles([]);
//       setUploadProgress({});
//     } catch (error) {
//       const msg = error.response?.data?.details || 'One or more uploads failed.';
//       setMessage(msg);
//       setUploadSuccess(false);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCancel = () => {
//     setAttachmentCategoryID('');
//     setAttachmentTypeID('');
//     setDescription('');
//     setCountyId('');
//     setTypes([]);
//     setFiles([]);
//     setUploadProgress({});
//   };

//   return (
//     <div style={styles.mainContainer}>
//       <Navbar username={username} onLogout={onLogout} isAdmin={isAdmin} />
//       <UploadForm
//         {...{
//           categories, types, counties, isAdmin,
//           files, attachmentCategoryID, attachmentTypeID, countyId, description,
//           isLoading, message, uploadSuccess, styles,
//           handleCategoryChange, setAttachmentTypeID, setCountyId, setDescription, setFiles,
//           handleSubmit, handleCancel, handleRemoveFile, uploadProgress
//         }}
//       />
//     </div>
//   );
// };

// export default AddNew;


